import { render } from "./UnblockButtonRenderer.vue?vue&type=template&id=4b7bc832"
import script from "./UnblockButtonRenderer.vue?vue&type=script&lang=js"
export * from "./UnblockButtonRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__